import { render, staticRenderFns } from "./MeasurementUnitsSelector.vue?vue&type=template&id=890197a6&scoped=true&"
import script from "./MeasurementUnitsSelector.vue?vue&type=script&lang=js&"
export * from "./MeasurementUnitsSelector.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementUnitsSelector.vue?vue&type=style&index=0&id=890197a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890197a6",
  null
  
)

export default component.exports